app = angular.module("seismology")

ref = firebase.database().ref()

app.factory "DailyStats", ($firebaseObject, $firebaseArray, Users) ->

  statsRef = ref.child('daily-stats')

  get: (key) ->
    $firebaseObject(statsRef.child(key))

  getRecent: (days=1)->
    $firebaseArray(statsRef.limitToLast(days))



app.factory "DiscussionCategories", ->
  news: {name: 'お知らせ', value: 'news', cls: 'bg-balanced'}
  question: {name: '質問', value: 'question', cls: 'bg-positive'}
  information: {name: '情報提供', value: 'information', cls: 'bg-calm'}
  bug: {name: '不具合報告', value: 'bug', cls: 'bg-assertive'}
  request: {name: '機能改善要望', value: 'request', cls: 'bg-energized'}
  others: {name: 'その他', value: 'others', cls: 'bg-royal'}
  

app.factory "Discussion", ($firebaseObject, $firebaseArray, $firebaseAuth, Commentable, Likable, Notification, DiscussionCategories) ->

  factory = angular.extend(angular.extend({}, Likable), Commentable)
  factory.imageCount = ->
    return 0 unless @images
    Object.keys(@images).length
  factory.isCreatedBy = (user) ->
    user.$id is @uid
  factory.getUser= ->
    Users.get(@uid)
  # override
  factory.notifyLiked = ->
    uid = $firebaseAuth().$getAuth().uid
    Notification.discussionLiked(@$id, uid)
  factory.notifyCommentCreated = (comment)->
    Notification.discussionCommentCreated(@$id, comment.key)
  factory.notifyCommentLiked = (comment)->
    uid = $firebaseAuth().$getAuth().uid
    Notification.discussionCommentLiked(@$id, comment.$id, uid)

  factory.getCategory = ->
    DiscussionCategories[@category]

  $firebaseObject.$extend(factory)

app.factory "DiscussionList", ($firebaseArray, Discussion) ->

  $firebaseArray.$extend
    $$added: (snap) ->      
      new Discussion(snap.ref)
    $$updated: (snap)->
      @$getRecord(snap.key).$$updated(snap)


app.factory "DiscussionFactory", ($firebaseArray, DiscussionList, CurrentUser, ImageUpload, Discussion) ->
  discussionsRef = ref.child('discussions')

  add: (discussion={}, images=[]) ->
    # ブロック対象ユーザーの投稿を禁止    
    if CurrentUser.get().blocked
      return alert "質問の投稿はできません。"
    discussion.timestamp = firebase.database.ServerValue.TIMESTAMP
    discussion.rtimestamp = -Date.now()
    discussion.updateTimestamp = firebase.database.ServerValue.TIMESTAMP
    discussion.updateRtimestamp = -Date.now()
    discussion.commentSize = 0
    discussion.rcommentSize = 0
    discussion.uid = CurrentUser.get().$id
    list = $firebaseArray(discussionsRef)
    if images.length > 0
      imageList = []
      for image in images        
        imageList.push(file: image)
      ImageUpload.uploadImageList(imageList)
        .then (data)->
          console.log "image upload success"
          discussion.images = (d.public_id for d in data)
          list.$add(discussion)
    else
      list.$add(discussion).then (discussionsRef) ->
        console.log discussionsRef

  get: (id) ->
    new Discussion(discussionsRef.child(id))

  getLatest: ->
    new DiscussionList(new firebase.util.Scroll(discussionsRef, 'rtimestamp'))
  
  getPopular: ->
    new DiscussionList(new firebase.util.Scroll(discussionsRef, 'rcommentSize'))

  getUpdated: ->
    new DiscussionList(new firebase.util.Scroll(discussionsRef, 'updateRtimestamp'))


app.factory "BookFactory", ($firebaseObject, $firebaseArray, Users) ->
  $firebaseObject.$extend
    size: ->
      if this.images then this.images.length else 0

    toggleFav: ->
      user = Users.current()
      user.favs ||= {}
      if user.favs[@$id]
        delete user.favs[@$id]
      else
        user.favs[@$id] = true
      user.$save()

    isFaved: ->
      Users.current().favs[@$id]

    updateProgress: ->
      finished = $firebaseArray(ref.child('transcriptions').child(@$id).orderByChild('status').equalTo('finished'))
      finished.$loaded =>
        console.log finished.length
        @progress = finished.length
        @$save()

    progressPrecentage:->
      return 0 unless @progress      
      (@progress/@size)*100
    

app.factory "Books", ($firebaseArray, BookFactory) ->
  bookRef = ref.child('books')

  all: ->
    $firebaseArray(bookRef.orderByChild('difficulty'))

  getByStage: (stageNum) ->
    $firebaseArray(bookRef.orderByChild('stage').equalTo(stageNum))
  
  get: (id) ->
    new BookFactory(bookRef.child(id))



app.factory "UserFavs", ($firebaseArray, $firebaseObject, $firebaseAuth, $firebaseUtils) ->

  UserFav = $firebaseObject.$extend
    toggle: ->
      @$loaded (fav)->
        if fav.$value
          fav.$remove()
        else
          fav.$value = true
          fav.$save()
    bookId: ->
      @$id
  
  getRef: ->
    uid = $firebaseAuth().$getAuth().uid
    ref.child('users').child(uid).child('favs')

  getList: ->    
    $firebaseArray(@getRef())

  getFav: (bookId) ->
    new UserFav(@getRef().child(bookId))

app.factory "UserEditing", ($firebaseArray, $firebaseAuth) ->

  getList: ->
    console.log "getlist"
    uid = $firebaseAuth().$getAuth().uid
    console.log uid
    editingRef = ref.child('users').child(uid).child('editing')
    console.log editingRef    
    $firebaseArray(editingRef)


app.factory "ForumFactory", ($firebaseArray, $firebaseAuth) ->
  $firebaseArray.$extend
    addMessage: (text) ->
      @$add
        text: text
        uid: $firebaseAuth().$getAuth().uid
        timestamp: firebase.database.ServerValue.TIMESTAMP

app.factory "ForumMessageList", ($firebaseArray, $firebaseAuth, ForumFactory) ->
  forumsRef = ref.child('forum')

  get: (bookId, size=20) ->
    forumRef = forumsRef.child(bookId).orderByChild("timestamp").limitToLast(size)
    new ForumFactory(forumRef)


app.factory "TimelineEvent", ($firebaseObject, $firebaseAuth, Likable, Notification) ->

  factory = angular.extend({}, Likable)
  # override
  factory.notifyLiked = ->
    Notification.timelineEventLiked(@$id)
  $firebaseObject.$extend(factory)

app.factory "TimelineList", ($firebaseArray, TimelineEvent, Notification) ->

  $firebaseArray.$extend
    $$added: (snap) ->      
      new TimelineEvent(snap.ref)
    $$updated: (snap)->
      @$getRecord(snap.key).$$updated(snap)

app.factory "Timeline", ($firebaseArray, $firebaseAuth, TimelineList, Notification) ->
  timelineRef = ref.child('timeline')

  getList: (limit = 30) ->
    new TimelineList(timelineRef.orderByChild('shared').equalTo(true).limitToLast(limit))

  getListByCode: (code, limit = 100) ->
    query = timelineRef.orderByChild('code').equalTo(code).limitToLast(limit)
    new TimelineList(query)

  getListByUid: (uid, limit = 100) ->
    query = timelineRef.orderByChild('uid').equalTo(uid).limitToLast(limit)
    new TimelineList(query)

  $add: (data = {})->
    data.uid = $firebaseAuth().$getAuth().uid
    data.timestamp = firebase.database.ServerValue.TIMESTAMP
    @getList().$add(data).then (eventRef)=>
      @notifyCreated(eventRef.key, data.code)

  # 過去翻刻した参加者に通知を送る
  notifyCreated: (eventId, code)->
    @getListByCode(code).$loaded (list) ->
      hash = {}      
      hash[event.uid] = true for event in list        
      predesessorIds = Object.keys(hash)
      console.log 'func', Notification
      Notification.timelineEventCreated(eventId, predesessorIds)

app.factory "Quakes", () ->

  class Quake
    constructor: (data) ->
      @data = data
      @setDate()
      
    setDate: ->
      ary = @data.date.match(/^(\d+) +(-|\d+) +(-|\d+)$/)
      @date = {
        year: parseInt(ary[1])
        month: parseInt(ary[2])
        day: parseInt(ary[3])
      }
    getDateString: ->
      str = "#{@date.year}年"
      str+= "#{@date.month}月" if @date.month
      str+= "#{@date.day}月" if @date.day
      str
    getDateJP: ->
      ary = @data.dateJP.match(/(.+) +(\d+) +(-|閏?\d+) +?(-|\d+)?/)
      str = ary[1]
      str += "#{parseInt(ary[2])}年"
      str+= "#{ary[3]}月" if ary[3] and ary[3] isnt "-"
      str+= "#{ary[4]}月" if ary[4] and ary[4] isnt "-"
      str

    getName: ->
      @data.name
    getComment: ->
      @date.comment

  rows = require("../data/quakes.csv")

  getList: ->
    rows.map (data) -> new Quake(data)
  



// WEBPACK FOOTER //
// ./app/services/services.coffee